export const LEGAL_DOCS_RU = {
  privacy: {
    title: "Политика конфиденциальности",
    path: "/privacy-policy",
    sections: [
      {
        heading: "1. Введение",
        paragraphs: [
          "VCK Business Lab (\"VCK\", \"мы\", \"нас\") — компания виртуальной бизнес-поддержки с офисом в Эдмонтоне, Альберта, Канада, обслуживающая клиентов в Канаде и за рубежом. Настоящая Политика конфиденциальности объясняет, как мы собираем, используем, раскрываем, храним и защищаем персональную информацию при работе веб-сайта и предоставлении наших услуг.",
          "Эта политика построена на принципах Закона Альберты о защите персональной информации (PIPA). Если вы находитесь за пределами Альберты, могут также применяться обязательные законы о конфиденциальности вашей юрисдикции, и ничто в настоящей политике не призвано исключить права, которые законно не могут быть отклонены.",
        ],
      },
      {
        heading: "2. Какую персональную информацию мы можем собирать",
        bullets: [
          "Контактная информация — имя, адрес электронной почты, номер телефона, название компании, страна и предпочтительный способ связи.",
          "Информация о запросах и расчётах стоимости — детали, которыми вы делитесь в контактных формах, запросах на расчёт, бронированиях консультаций и переписке, включая тип необходимой поддержки.",
          "Информация о клиентах и проектах — документы, инструкции, детали проектов и другие материалы, которые вы предоставляете для выполнения услуг.",
          "Платёжная информация — номера счетов, суммы платежей и записи о транзакциях. Номера карт обрабатываются нашим платёжным провайдером (Stripe) и никогда не хранятся на наших серверах.",
          "Информация об использовании веб-сайта и техническая информация — просмотренные страницы, тип браузера, устройство, приблизительное местоположение и страницы, с которых вы перешли.",
        ],
      },
      {
        heading: "3. Файлы cookie и аналитика",
        paragraphs: [
          "Наш веб-сайт использует небольшое количество файлов cookie — например, чтобы запомнить ваш языковой выбор, — а также может использовать бережную к конфиденциальности аналитику, чтобы понять, как используется сайт. Подробности и способы управления cookie через настройки браузера описаны в нашей Политике cookies.",
        ],
      },
      {
        heading: "4. Зачем мы собираем информацию",
        bullets: [
          "Чтобы отвечать на запросы и готовить расчёты стоимости.",
          "Чтобы планировать и предоставлять консультации и услуги.",
          "Чтобы управлять отношениями с клиентами, проектами, выставлением счетов и платежами.",
          "Чтобы отправлять служебные сообщения, например подтверждения бронирования и напоминания о встречах.",
          "Чтобы улучшать наш веб-сайт, услуги и клиентский опыт.",
          "Чтобы выполнять юридические, бухгалтерские и учётные обязательства.",
        ],
      },
      {
        heading: "5. Согласие",
        paragraphs: [
          "Отправляя запрос, бронируя консультацию или заказывая наши услуги, вы соглашаетесь на сбор, использование и раскрытие вашей персональной информации, как описано в настоящей политике. Вы можете в любой момент отозвать согласие, связавшись с нами, с учётом юридических и договорных ограничений; отзыв согласия может ограничить нашу возможность предоставлять вам услуги.",
        ],
      },
      {
        heading: "6. Использование и раскрытие",
        paragraphs: [
          "Мы используем персональную информацию только для описанных выше целей или для совместимых с ними целей. Мы не продаём персональную информацию. Мы раскрываем персональную информацию только по мере необходимости для предоставления услуг, как описано в настоящей политике, или если это требуется либо разрешается законом.",
        ],
      },
      {
        heading: "7. Поставщики услуг и субподрядчики",
        paragraphs: [
          "Мы можем работать с доверенными поставщиками услуг и субподрядчиками (например, переводчиками, административными специалистами или техническими помощниками), которые помогают в выполнении вашего проекта. Они получают доступ только к информации, необходимой для их работы, и обязаны защищать её в соответствии с обязательствами о конфиденциальности.",
        ],
      },
      {
        heading: "8. Облачные и программные провайдеры",
        paragraphs: [
          "Мы используем надёжных облачных и программных провайдеров для электронной почты, планирования, хранения файлов, управления проектами, обработки платежей и хостинга веб-сайта. Ваша информация может обрабатываться этими сторонними технологическими провайдерами от нашего имени в соответствии с их собственными практиками безопасности и конфиденциальности.",
        ],
      },
      {
        heading: "9. Международная обработка данных",
        paragraphs: [
          "Поскольку мы работаем виртуально и обслуживаем клиентов по всему миру, ваша информация может обрабатываться сторонними технологическими провайдерами и храниться за пределами вашей провинции или страны, в том числе в Соединённых Штатах или других юрисдикциях, если это разрешено законом. Информация, хранящаяся в другой юрисдикции, может подпадать под законы этой юрисдикции.",
        ],
      },
      {
        heading: "10. Информационная безопасность",
        paragraphs: [
          "Мы применяем разумные административные, технические и физические меры защиты, соответствующие чувствительности информации, — включая контроль доступа, защищённые платформы и практики конфиденциальности. Однако ни один способ передачи или хранения не является абсолютно безопасным, и мы не можем гарантировать абсолютную безопасность данных.",
        ],
      },
      {
        heading: "11. Конфиденциальная информация клиентов",
        paragraphs: [
          "Материалы клиентов, деловая информация и детали проектов считаются конфиденциальными, используются только для предоставления ваших услуг и передаются только лицам и провайдерам, участвующим в вашем заказе, или если это требуется законом.",
        ],
      },
      {
        heading: "12. Хранение и безопасное удаление",
        paragraphs: [
          "Мы храним персональную информацию только столько времени, сколько это необходимо для целей, для которых она собиралась, а также для выполнения юридических, бухгалтерских или договорных требований. Когда информация больше не нужна, она безопасно удаляется или уничтожается.",
        ],
      },
      {
        heading: "13. Запросы на доступ и исправление",
        paragraphs: [
          "Вы можете запросить доступ к вашей персональной информации или попросить её исправить, связавшись с нами по адресу ниже. Мы ответим в разумный срок и в соответствии с действующим законодательством.",
        ],
      },
      {
        heading: "14. Жалобы на конфиденциальность",
        paragraphs: [
          "Если у вас есть опасения по поводу нашего обращения с персональной информацией, сначала свяжитесь с нами, чтобы мы могли попытаться решить вопрос. Если вы не удовлетворены, вы можете обратиться в Офис Комиссара по информации и конфиденциальности Альберты.",
        ],
      },
      {
        heading: "15. Инциденты безопасности и утечки данных",
        paragraphs: [
          "Если инцидент безопасности создаёт реальный риск значительного вреда, мы уведомим об этом пострадавших лиц и соответствующего регулятора, как это требуется действующим законодательством, и примем разумные меры для снижения риска вреда.",
        ],
      },
      {
        heading: "16. Специалист по защите данных",
        paragraphs: [
          "Специалист по защите данных отвечает за вопросы конфиденциальности, запросы на доступ и исправление, жалобы и реагирование на инциденты конфиденциальности. Со специалистом по защите данных можно связаться по адресу:",
          "Специалист по защите данных, VCK Business Lab, Эдмонтон, Альберта, Канада — office@vckbusinesslab.com",
        ],
      },
      {
        heading: "17. Маркетинговые коммуникации (CASL)",
        paragraphs: [
          "VCK Business Lab может отправлять коммерческие электронные сообщения только в пределах, разрешённых действующим законодательством, включая Канадский закон о борьбе со спамом (CASL). Где это требуется, VCK получает согласие перед отправкой рекламных сообщений.",
          "Коммерческие сообщения от VCK идентифицируют VCK Business Lab, содержат действительную контактную информацию и работающий механизм отписки. Вы можете в любой момент отозвать согласие на получение маркетинговых сообщений, и запросы на отписку обрабатываются незамедлительно и в срок, установленный законом.",
          "После запроса на отписку мы можем хранить ограниченную информацию для подавления, чтобы гарантировать, что вы случайно не будете снова добавлены в маркетинговые списки.",
        ],
      },
      {
        heading: "18. Изменения в настоящую политику",
        paragraphs: [
          "Мы можем время от времени обновлять настоящую Политику конфиденциальности. Текущая версия всегда будет размещена на этой странице с датой «Последнее обновление».",
        ],
      },
      {
        heading: "19. Контакт по вопросам конфиденциальности",
        paragraphs: [
          "Вопросы о конфиденциальности, запросы на доступ или исправление и жалобы можно направлять на office@vckbusinesslab.com. VCK Business Lab находится в Эдмонтоне, Альберта, Канада.",
        ],
      },
    ],
  },
  terms: {
    title: "Условия использования веб-сайта",
    path: "/terms-of-use",
    sections: [
      {
        heading: "1. Принятие этих условий",
        paragraphs: [
          "Получая доступ к веб-сайту VCK Business Lab или используя его, вы принимаете настоящие Условия использования веб-сайта. Если вы не согласны, пожалуйста, не используйте веб-сайт.",
        ],
      },
      {
        heading: "2. Информационная цель",
        paragraphs: [
          "Этот веб-сайт предоставляется с общей информационной целью о VCK Business Lab и её услугах. Содержимое веб-сайта не является офертой, а заказ услуг оформляется только через письменный расчёт стоимости, договор об оказании услуг, техническое задание или подтверждение бронирования.",
        ],
      },
      {
        heading: "3. Никаких профессиональных консультаций",
        paragraphs: [
          "Ничто на этом веб-сайте не является профессиональной консультацией любого рода — включая юридическую, бухгалтерскую, налоговую, иммиграционную, медицинскую или инженерную. VCK Business Lab не предоставляет профессиональные инженерные услуги, юридические консультации, бухгалтерские или налоговые консультации, иммиграционные или медицинские консультации, и содержимое веб-сайта не следует рассматривать как таковое.",
        ],
      },
      {
        heading: "4. Отсутствие клиентских отношений",
        paragraphs: [
          "Использование этого веб-сайта, отправка запроса, бронирование консультации или получение ответа не создаёт клиентских отношений. Клиентские отношения начинаются только тогда, когда письменный расчёт стоимости, договор об оказании услуг, техническое задание или подтверждение бронирования приняты обеими сторонами.",
        ],
      },
      {
        heading: "5. Интеллектуальная собственность",
        paragraphs: [
          "Содержимое этого веб-сайта — включая текст, дизайн, графику, логотипы и макет — принадлежит VCK Business Lab или используется по лицензии и защищено действующими законами об интеллектуальной собственности. Вы можете просматривать веб-сайт и делиться ссылками на него, но не можете копировать, воспроизводить или публиковать его содержимое в коммерческих целях без письменного разрешения.",
        ],
      },
      {
        heading: "6. Разрешённое и запрещённое использование",
        paragraphs: [
          "Вы можете использовать этот веб-сайт только в законных целях. Вы соглашаетесь не злоупотреблять веб-сайтом, не пытаться получить несанкционированный доступ к любой его части или системам, не собирать информацию массово, не подавать ложную или вводящую в заблуждение информацию, не мешать работе веб-сайта и не использовать его способом, нарушающим действующее законодательство.",
        ],
      },
      {
        heading: "7. Точность информации",
        paragraphs: [
          "Мы работаем над тем, чтобы информация на веб-сайте была точной и актуальной, но не гарантируем, что всё содержимое всегда является полным, точным или актуальным. Описания услуг, доступность и цены могут изменяться.",
        ],
      },
      {
        heading: "8. Цены",
        paragraphs: [
          "Цены, указанные на этом веб-сайте, являются начальными или ориентировочными, если они не подтверждены в письменном расчёте стоимости или договоре для вашего конкретного проекта. Окончательная цена зависит от объёма, сложности, объёма работ, срочности и условий, согласованных письменно.",
        ],
      },
      {
        heading: "9. Сторонние ссылки и сервисы",
        paragraphs: [
          "Этот веб-сайт ссылается на сторонние сервисы или интегрируется с ними, например планирование (Cal.com), обработка платежей (Stripe) и обмен сообщениями (WhatsApp). Мы не контролируем сторонние веб-сайты и сервисы и не несём ответственности за их содержимое или практики конфиденциальности.",
        ],
      },
      {
        heading: "10. Доступность и перерывы",
        paragraphs: [
          "Мы стремимся обеспечивать доступность веб-сайта, но он может время от времени прерываться или быть недоступным — из-за технического обслуживания, обновлений, технических проблем или причин вне нашего контроля — без предупреждения.",
        ],
      },
      {
        heading: "11. Ограничение ответственности",
        paragraphs: [
          "В максимальной степени, разрешённой действующим законодательством, VCK Business Lab не несёт ответственности за любые косвенные, случайные, побочные или специальные убытки, возникающие в результате использования или невозможности использования этого веб-сайта или его содержимого. Ничто в настоящих условиях не исключает и не ограничивает ответственность, которая законно не может быть исключена или ограничена.",
        ],
      },
      {
        heading: "12. Возмещение убытков",
        paragraphs: [
          "В пределах, разрешённых законом, вы соглашаетесь возместить VCK Business Lab убытки и защитить её от претензий, потерь или расходов, возникающих в результате вашего неправильного использования этого веб-сайта или нарушения настоящих условий.",
        ],
      },
      {
        heading: "13. Изменения веб-сайта или настоящих условий",
        paragraphs: [
          "Мы можем время от времени обновлять веб-сайт и настоящие условия. Текущая версия будет размещена на этой странице с датой «Последнее обновление», и дальнейшее использование веб-сайта означает ваше согласие с обновлёнными условиями.",
        ],
      },
      {
        heading: "14. Действующее право",
        paragraphs: [
          "Настоящие условия регулируются законами провинции Альберта и применимыми федеральными законами Канады. Если вы получаете доступ к этому веб-сайту из другой юрисдикции, могут также применяться обязательные местные законы этой юрисдикции, и ничто в настоящих условиях не призвано отменить права, которые законно не могут быть отклонены.",
        ],
      },
    ],
  },
  service: {
    title: "Условия оказания услуг и общее заявление",
    path: "/service-terms",
    sections: [
      {
        heading: "1. Как начинается сотрудничество",
        paragraphs: [
          "Все услуги VCK Business Lab требуют принятия расчёта стоимости, договора об оказании услуг, технического задания, подтверждения бронирования или другого письменного соглашения до начала работы. Ничто на этом веб-сайте — включая описания услуг и указанные цены — само по себе не создаёт заказ.",
        ],
      },
      {
        heading: "2. Объём, сроки и стоимость",
        paragraphs: [
          "Все услуги предоставляются при наличии возможности. Объём, результаты, сроки, количество правок и стоимость зависят от конкретного проекта и определяются в письменном расчёте стоимости или договоре для этого заказа. Условия подписанного договора имеют приоритет над общей информацией на веб-сайте.",
        ],
      },
      {
        heading: "3. Информация и материалы клиента",
        paragraphs: [
          "Клиент отвечает за предоставление полной, точной и своевременной информации, инструкций и материалов. VCK может полагаться на информацию и материалы, предоставленные клиентом, и не несёт ответственности за ошибки в конечной работе, возникшие из-за неточной или неполной предоставленной клиентом информации.",
        ],
      },
      {
        heading: "4. Задержки со стороны клиента",
        paragraphs: [
          "Сроки предполагают своевременную коммуникацию и согласования со стороны клиента. Задержки со стороны клиента — например, поздняя обратная связь, отсутствие материалов или отложенные согласования — могут соответственно влиять на сроки и даты сдачи.",
        ],
      },
      {
        heading: "5. Отсутствие гарантированных результатов",
        paragraphs: [
          "VCK Business Lab не гарантирует конкретных бизнес-результатов, включая продажи, доход, прибыль, позиции в поисковых системах, трафик веб-сайта, привлечение клиентов, регуляторное принятие документов или другие результаты. Мы обязуемся работать профессионально и добросовестно, а не гарантировать конкретные результаты, которые зависят от многих факторов вне нашего контроля.",
        ],
      },
      {
        heading: "6. Исправления",
        paragraphs: [
          "Если VCK допустит существенную ошибку в услуге, пожалуйста, незамедлительно сообщите нам. В соответствии с действующим законодательством, VCK должна получить разумную возможность исправить или повторно выполнить соответствующую работу до прибегания к другим средствам защиты.",
        ],
      },
      {
        heading: "7. Сторонние сервисы",
        paragraphs: [
          "Стороннее программное обеспечение, хостинг-провайдеры, регистраторы доменов, плагины, платёжные платформы, инструменты планирования и подобные сервисы находятся вне непосредственного контроля VCK. Мы не несём ответственности за сбои, изменения, потерю данных, изменение цен или прекращение работы сторонних сервисов, хотя приложим разумные усилия, чтобы помочь вам адаптироваться.",
        ],
      },
      {
        heading: "8. Проверка и утверждение",
        paragraphs: [
          "Клиент отвечает за проверку и утверждение финального контента, документов, переводов и веб-материалов перед публикацией или использованием. После утверждения или публикации клиентом ответственность за использование финального материала несёт клиент.",
        ],
      },
      {
        heading: "9. Отношение к подписанным договорам",
        paragraphs: [
          "Настоящие Условия оказания услуг дополняют — и не заменяют — любой Мастер-договор об оказании услуг, подписанный расчёт стоимости, график услуг или Техническое задание между вами и VCK Business Lab. В случае противоречия действует подписанный договор.",
        ],
      },
    ],
  },
  translation: {
    title: "Заявление о переводческих услугах",
    path: "/translation-disclaimer",
    sections: [
      {
        heading: "1. Общие и деловые языковые услуги",
        paragraphs: [
          "Стандартные публично рекламируемые языковые услуги VCK Business Lab — это общий и деловой письменный и устный перевод для повседневной деловой коммуникации, встреч, документов, взаимодействия с клиентами, веб-сайтов, презентаций и подобных нерегулируемых целей.",
        ],
      },
      {
        heading: "2. Ваша ответственность объяснить назначение",
        paragraphs: [
          "Вы отвечаете за то, чтобы сообщить нам о назначении перевода и любых требованиях организации-получателя до начала работы, чтобы мы могли подтвердить, входит ли работа в нашу компетенцию.",
        ],
      },
      {
        heading: "3. Не сертифицирован, если прямо не указано",
        paragraphs: [
          "Общие переводы не следует автоматически считать сертифицированными, присяжными, юридическими или официально принимаемыми документами. VCK Business Lab не представляет свои стандартные услуги письменного и устного перевода как сертифицированные, присяжные, судебно-сертифицированные, юридические или официально аккредитованные, если это прямо не указано для конкретного проекта и не выполняется соответствующим квалифицированным специалистом.",
        ],
      },
      {
        heading: "4. Отсутствие гарантии принятия",
        paragraphs: [
          "Мы не гарантируем, что какой-либо перевод будет принят судами, государственными органами, иммиграционными службами, учебными заведениями, банками или другими третьими сторонами, если конкретное требование к квалификации не было подтверждено заранее и работа не была организована в соответствии с ним.",
        ],
      },
      {
        heading: "5. Факторы качества устного перевода",
        paragraphs: [
          "На качество устного перевода могут влиять факторы вне нашего контроля, включая качество звука и соединения, специализированную терминологию, неполную исходную информацию, перерывы и темп или чёткость речи участников. Предоставление материалов, глоссариев и контекста заранее помогает нам обеспечить наилучший возможный результат.",
        ],
      },
      {
        heading: "6. Не замена профессиональной консультации",
        paragraphs: [
          "Общий деловой устный и письменный перевод не заменяет юридическую, медицинскую или иную регулируемую профессиональную консультацию. Судебный, юридический, медицинский или иной регулируемый либо специализированный перевод предоставляется только по предварительной договорённости и если исполнитель соответствует действующим требованиям.",
        ],
      },
    ],
  },
  website: {
    title: "Заявление о веб-услугах",
    path: "/website-disclaimer",
    sections: [
      {
        heading: "1. Права на контент и разрешения",
        paragraphs: [
          "Клиент отвечает за владение или наличие разрешения на использование всего контента, предоставленного для веб-проекта, — включая тексты, изображения, логотипы, видео, шрифты и торговые марки. VCK может полагаться на подтверждение клиента, что предоставленные материалы надлежащим образом лицензированы.",
        ],
      },
      {
        heading: "2. Домены и хостинг",
        paragraphs: [
          "Если проектный договор не предусматривает иное, доменные имена и хостинг-аккаунты регистрируются на имя клиента и остаются ответственностью клиента, включая продление. Мы можем координировать настройку и продление в рамках согласованного объёма, но применяются условия сторонних регистраторов и хостинг-провайдеров.",
        ],
      },
      {
        heading: "3. Стороннее программное обеспечение, плагины и приложения",
        paragraphs: [
          "Веб-сайты часто полагаются на сторонние платформы, темы, плагины и приложения. Они вне непосредственного контроля VCK: они могут изменяться, обновляться, прекращаться, иметь уязвимости или со временем становиться несовместимыми.",
        ],
      },
      {
        heading: "4. Электронная коммерция и платёжные провайдеры",
        paragraphs: [
          "Онлайн-платежи обрабатываются сторонними провайдерами (например, Stripe). Применяются условия, комиссии, практики безопасности и доступность этих провайдеров, и VCK не несёт ответственности за их сбои, решения или действия в отношении аккаунтов.",
        ],
      },
      {
        heading: "5. Ограничения безопасности",
        paragraphs: [
          "Мы соблюдаем разумные практики безопасности при создании и обслуживании веб-сайтов, но ни один веб-сайт не может быть полностью безопасным, бесперебойным или безошибочным. Безопасность — это общая, постоянная ответственность, включающая сохранение клиентом своих аккаунтов и учётных данных в безопасности.",
        ],
      },
      {
        heading: "6. Резервные копии",
        paragraphs: [
          "Условия резервного копирования зависят от платформы и согласованного объёма. Если постоянное обслуживание с резервным копированием не входит в ваш договор, клиент отвечает за собственное резервное копирование.",
        ],
      },
      {
        heading: "7. Изменения совместимости",
        paragraphs: [
          "Браузеры, устройства и платформы развиваются. Веб-сайт, который работает сегодня, в будущем может потребовать обновлений для сохранения совместимости; такие обновления выходят за рамки первоначальной разработки, если они не покрыты планом обслуживания.",
        ],
      },
      {
        heading: "8. Позиции в поисковых системах",
        paragraphs: [
          "Мы создаём веб-сайты с соблюдением надлежащих технических и контентных практик, но не гарантируем позиции в поисковых системах, скорость индексации, уровень трафика или место по какому-либо ключевому слову.",
        ],
      },
      {
        heading: "9. Доступность и юридическое соответствие",
        paragraphs: [
          "Где это применимо, клиент отвечает за сообщение нам о конкретных требованиях к доступности, конфиденциальности или регуляторному соответствию для своего веб-сайта (например, законодательство о доступности или отраслевые правила), чтобы их можно было учесть в согласованном объёме. Если это прямо не включено в договор, формальные аудиты доступности и юридические проверки соответствия не входят в разработку веб-сайта.",
        ],
      },
      {
        heading: "10. Утверждение клиентом перед запуском",
        paragraphs: [
          "Веб-сайты запускаются только после проверки и утверждения клиентом. После утверждения и запуска ответственность за опубликованный контент несёт клиент.",
        ],
      },
      {
        heading: "11. Постоянное обслуживание",
        paragraphs: [
          "Обновления, мониторинг и обслуживание после запуска предоставляются только если они включены в письменный договор или ежемесячный план поддержки.",
        ],
      },
    ],
  },
  refund: {
    title: "Политика оплаты, отмены и возврата",
    path: "/refund-policy",
    sections: [
      {
        heading: "1. Структура оплаты",
        bullets: [
          "Небольшие проекты могут требовать полной оплаты до начала работы.",
          "Более крупные проекты могут требовать депозита с этапными и финальными платежами, как указано в расчёте стоимости или договоре.",
          "Ежемесячные планы поддержки оплачиваются заранее за каждый расчётный период.",
          "Оплата производится по защищённой платёжной ссылке, которую VCK Business Lab отправляет вам напрямую после подтверждения услуги, объёма и стоимости — этот сайт не предлагает публичной страницы оплаты.",
          "Приоритетная, срочная или экстренная работа может требовать предоплаты.",
        ],
      },
      {
        heading: "2. Депозиты",
        paragraphs: [
          "Депозиты резервируют время и ресурсы для вашего проекта. В пределах, разрешённых законом, депозит может стать невозвратным после начала работы.",
        ],
      },
      {
        heading: "3. Выполненная работа и затраченное время",
        paragraphs: [
          "Завершённая работа и уже затраченное время, как правило, не подлежат возврату, поскольку их невозможно вернуть.",
        ],
      },
      {
        heading: "4. Если мы допустим существенную ошибку",
        paragraphs: [
          "Если VCK допустит существенную ошибку в предоставленной работе, пожалуйста, незамедлительно сообщите нам. В соответствии с действующим законодательством, VCK сначала должна получить разумную возможность исправить или повторно выполнить соответствующую работу до рассмотрения возвратов или других средств защиты.",
        ],
      },
      {
        heading: "5. Отмена",
        paragraphs: [
          "Условия отмены могут различаться в зависимости от услуги и вашего подписанного договора. Для ежемесячных планов поддержки отмена вступает в силу в соответствии с вашим договором — обычно в конце текущего предоплаченного расчётного периода, — а суммы, уже выставленные за текущий период, не возвращаются, если это не требуется законом или не указано в вашем договоре.",
        ],
      },
      {
        heading: "6. Расходы на третьих лиц",
        paragraphs: [
          "Расходы на третьих лиц и уже понесённые от вашего имени расходы (например, домены, лицензии на программное обеспечение, стоковые материалы или уже выполненная субподрядная работа), как правило, не подлежат возврату.",
        ],
      },
      {
        heading: "7. Ваши обязательные права",
        paragraphs: [
          "Ничто в настоящей политике не отменяет и не ограничивает любые обязательные права потребителя, которые вы имеете по действующему законодательству. Если эти законы дают вам дополнительные права, они продолжают применяться.",
        ],
      },
    ],
  },
  cookies: {
    title: "Политика cookies",
    path: "/cookie-policy",
    sections: [
      {
        heading: "1. Что такое cookies",
        paragraphs: [
          "Cookies — это небольшие текстовые файлы, сохраняемые на вашем устройстве при посещении веб-сайта. Они помогают веб-сайтам работать, запоминать предпочтения и понимать, как используется сайт.",
        ],
      },
      {
        heading: "2. Cookies, которые мы используем",
        bullets: [
          "Необходимые cookies — требуются для работы веб-сайта (например, cookies безопасности и балансировки нагрузки от нашей хостинг-платформы).",
          "Функциональные cookies — запоминают ваш выбор, например предпочтительный язык веб-сайта.",
          "Аналитические cookies — могут использоваться для обобщённого понимания того, как посетители пользуются сайтом, чтобы мы могли его улучшать.",
          "Сторонние интеграции — некоторые встроенные или связанные сервисы (например, инструменты планирования, оплаты или обмена сообщениями) могут устанавливать собственные cookies при вашем взаимодействии с ними в соответствии с их политиками конфиденциальности.",
        ],
      },
      {
        heading: "3. Как управлять cookies",
        paragraphs: [
          "Вы можете управлять или удалять cookies через настройки браузера в любой момент, и большинство браузеров позволяет полностью блокировать cookies или предупреждать перед сохранением cookie. Если сайт предоставляет инструмент настройки cookies, вы также можете управлять необязательными cookies там. Блокировка некоторых cookies может повлиять на работу частей веб-сайта.",
        ],
      },
      {
        heading: "4. Изменения в настоящую политику",
        paragraphs: [
          "Мы можем обновлять настоящую Политику cookies по мере развития веб-сайта. Текущая версия всегда будет размещена на этой странице с датой «Последнее обновление».",
        ],
      },
    ],
  },
  accessibility: {
    title: "Заявление о доступности",
    path: "/accessibility",
    sections: [
      {
        heading: "1. Наше обязательство",
        paragraphs: [
          "VCK Business Lab стремится сделать свой веб-сайт удобным и доступным для как можно большего числа людей, включая тех, кто использует вспомогательные технологии. Мы рассматриваем доступность как постоянный процесс, а не разовый проект.",
        ],
      },
      {
        heading: "2. Ваш отзыв важен",
        paragraphs: [
          "Если у вас возникли трудности с использованием какой-либо части этого веб-сайта или у вас есть предложения, которые сделают его доступнее для вас, пожалуйста, свяжитесь с нами по адресу office@vckbusinesslab.com. Мы рассмотрим ваш отзыв и постараемся внести разумные улучшения.",
        ],
      },
      {
        heading: "3. Добросовестное усилие",
        paragraphs: [
          "Это заявление отражает наше добросовестное обязательство по доступности. Мы не заявляем о формальной сертификации WCAG или полном соответствии какому-либо конкретному стандарту, и мы благодарны за возможность совершенствоваться.",
        ],
      },
    ],
  },
  newcomer: {
    title: "Дисклеймер поддержки новоприбывших",
    path: "/newcomer-disclaimer",
    sections: [
      {
        heading: "1. Объём услуг поддержки новоприбывших",
        paragraphs: [
          "VCK Business Lab предоставляет общие административные, языковые, переводческие, координационные и практические услуги поддержки.",
        ],
      },
      {
        heading: "2. Никаких иммиграционных или гражданских советов",
        paragraphs: [
          "VCK Business Lab не предоставляет иммиграционных советов или советов по гражданству и не осуществляет представительства, а также не действует как иммиграционный консультант или иммиграционный адвокат.",
          "Мы не консультируем клиентов по вопросам иммиграционного соответствия, иммиграционных программ, визовых или разрешительных стратегий, заявлений на постоянное местительство, заявлений на гражданство или того, как следует заполнять иммиграционные заявления.",
        ],
      },
      {
        heading: "3. Никаких иных регулируемых профессиональных советов",
        paragraphs: [
          "Мы также не предоставляем юридических, налоговых, финансовых, медицинских, образовательных, трудовых или иных регулируемых профессиональных советов.",
        ],
      },
      {
        heading: "4. Направление к лицензированным специалистам",
        paragraphs: [
          "Если клиенту требуются регулируемые профессиональные услуги, VCK Business Lab может порекомендовать обратиться к соответствующему лицензированному специалисту.",
          "Административная и языковая помощь, предоставляемая VCK Business Lab, не должна толковаться как профессиональный совет или представительство.",
        ],
      },
      {
        heading: "5. Контакты",
        paragraphs: [
          "VCK Business Lab — Эдмонтон, Альберта, Канада",
          "Email: office@vckbusinesslab.com • Телефон: +1 587 385 6058 • Сайт: vckbusinesslab.com",
        ],
      },
    ],
  },
};

export const LEGAL_LINKS_RU = [
  { key: "privacy", label: "Политика конфиденциальности" },
  { key: "terms", label: "Условия использования" },
  { key: "service", label: "Условия оказания услуг" },
  { key: "translation", label: "Заявление о переводе" },
  { key: "website", label: "Заявление о веб-услугах" },
  { key: "refund", label: "Оплата и возврат" },
  { key: "cookies", label: "Политика cookies" },
  { key: "accessibility", label: "Доступность" },
  { key: "newcomer", label: "Дисклеймер поддержки новоприбывших" },
];
